import axios from 'axios';
import { getRuntimeConfig } from './runtimeConfig';

// Backend-virtus (NestJS) — endpoints de cobrança/portal (ex.: geração de boleto).
// Difere do `api` (api-charge, /v1) usado na listagem de títulos.
const baseURL = getRuntimeConfig('REACT_APP_BACKEND_VIRTUS_URL');

const apiVirtus = axios.create({
  baseURL,
  timeout: 30000,
});

export default apiVirtus;
